import styled from 'styled-components';

export const FeedListBlock = styled.div`
    flex:  1 1 auto;
    overflow-y: scroll;
    height: 100%;
`;

export const FeedNotExistTxtBlock = styled.div`
    background: #f7f7f7;
    height: 100%;
    padding: calc(100vw * (16 / 375)) calc(100vw * (15 / 375));
`;

export const FeedNotExistTxt = styled.p`
    color: #c6c6c6;
    font-size: calc(100vw * (14 / 375));
`;